import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useRefresh } from '../context/RefreshContext';

export function useRevenue(startDate, endDate, { managerId } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { refreshCount } = useRefresh();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (managerId) params.manager_id = managerId;
    apiClient.get('/revenue/combined', { params })
      .then(res => { 
        if (!cancelled) {
          const resp = res.data;
          setData({
            invoices: resp.invoices || (Array.isArray(resp) ? resp : []),
            totalRevenue: resp.totalRevenue || 0,
            membershipRevenue: resp.membershipRevenue || 0,
            grandTotal: resp.grandTotal || 0,
            memberInvoices: resp.memberInvoices || [],
            breakdown: resp.breakdown || null,
          });
        }
      })
      .catch(err => { if (!cancelled) setError(err.response?.data?.error || 'Failed to load revenue'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [refreshCount, startDate, endDate, managerId]);

  return { 
    data: data.invoices || [], 
    revenueInfo: data,
    loading, 
    error 
  };
}
